// Auth data
export const authData = {
	state: {
		isLoggedIn: false,
		userId: '',
		email: '',
		name: '',
		token: '',
		role: {},
		tenant: {}
	},
	reducers: {
		toggleLoggedIn(state, payload) {
			return {
				...state,
				isLoggedIn: payload,
			};
		},
		setUserId(state, payload) {
			return {
				...state,
				userId: payload,
			};
		},
		setEmail(state, payload) {
			return {
				...state,
				email: payload,
			};
		},
		setName(state, payload) {
			return {
				...state,
				name: payload,
			};
		},
		setToken(state, payload) {
			return {
				...state,
				token: payload,
			};
		},
		setRole(state, payload) {
			return {
				...state,
				role: payload,
			};
		},
		setTenant(state, payload) {
			return {
				...state,
				tenant: payload,
			};
		},
		setState(state, payload) {
			return payload;
		},
		resetState(state, payload) {
			return {
				isLoggedIn: false,
				userId: '',
				email: '',
				name: '',
				token: '',
				role: {},
				tenant: {},
			};
		},
	},
	effects: (dispatch) => ({
		async setDataAsync(payload, rootState) {
			await new Promise((resolve) => resolve);
			dispatch.authData.toggleLoggedIn(payload);
			dispatch.authData.setUserId(payload);
			dispatch.authData.setEmail(payload);
			dispatch.authData.setName(payload);
			dispatch.authData.setToken(payload);
			dispatch.authData.setRole(payload);
			dispatch.authData.setTenant(payload);
			dispatch.authData.setState(payload);
			dispatch.authData.resetState(payload);
		},
	}),
}
